import { render, staticRenderFns } from "./fromComponent.vue?vue&type=template&id=5b68412b&scoped=true"
import script from "./fromComponent.vue?vue&type=script&lang=js"
export * from "./fromComponent.vue?vue&type=script&lang=js"
import style0 from "./fromComponent.vue?vue&type=style&index=0&id=5b68412b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b68412b",
  null
  
)

export default component.exports